import { apiCall } from './api.service';

export const getSubstitutions = async (token, organisationId) => {
    const method = 'get';
    const path = `api/v1/organisations/${organisationId}/substitutions`;

    const response = await apiCall(method, {}, path, token);
    return response;
};

export const getSubstitution = async (token, organisationId, substitutionId) => {
    const method = 'get';
    const path = `api/v1/organisations/${organisationId}/substitutions/${substitutionId}`;

    const response = await apiCall(method, {}, path, token);
    return response;
};

export const createSubstitution = async (token, organisationId, substitutionData) => {
    const method = 'post';
    const path = `api/v1/organisations/${organisationId}/substitutions`;

    const response = await apiCall(method, substitutionData, path, token);
    return response;
};

export const updateSubstitution = async (token, organisationId, substitutionId, substitutionData) => {
    const method = 'put';
    const path = `api/v1/organisations/${organisationId}/substitutions/${substitutionId}`;

    const response = await apiCall(method, substitutionData, path, token);
    return response;
};

export const deleteSubstitution = async (token, organisationId, substitutionId) => {
    const method = 'delete';
    const path = `api/v1/organisations/${organisationId}/substitutions/${substitutionId}`;

    const response = await apiCall(method, {}, path, token);
    return response;
};
